import { Box } from '@mui/material';
import { PlacesAutocompleteOption } from '../../../interfaces';
import { PlacesAutocomplete, PlacesAutocompleteProps } from '../..';
import { GlobalIcon, PlaceIcon } from '../../../icons';
import { Colors } from '../../../constants';

export const getIsOnlineEventByAddress = (address?: string): boolean => address?.trim().startsWith('http') ?? false;

interface PlaceAutocompleteWithOnlineProps<Multiple extends boolean | undefined = undefined> extends PlacesAutocompleteProps<Multiple> {
	address?: PlacesAutocompleteOption;
	isOnlineEvent: boolean;
	onlineUrl?: string;

	setAddress(value?: PlacesAutocompleteOption): void;

	setIsOnlineEvent(value?: boolean): void;

	setOnlineUrl(value?: string): void;
}

export const PlaceAutocompleteWithOnline = <Multiple extends boolean | undefined = true>(
	{
		address,
		isOnlineEvent,
		onlineUrl,
		setAddress,
		setIsOnlineEvent,
		setOnlineUrl,
		...props
	}: PlaceAutocompleteWithOnlineProps<Multiple>) => (
	<PlacesAutocomplete
		{...props}
		onSelect={value => {
			if (!value) {
				setAddress(undefined);
				setIsOnlineEvent(false);
				setOnlineUrl(undefined);

				return;
			}

			const option: PlacesAutocompleteOption | string = Array.isArray(value) ? value[0] : value;

			if (typeof option !== 'string') {
				setAddress(option);
				setIsOnlineEvent(false);
				setOnlineUrl(undefined);
			}
		}}
		onInputChange={value => {
			if (!value) {
				setAddress(undefined);
				setIsOnlineEvent(false);
				setOnlineUrl(undefined);
			}

			const addressName = value;
			const isOnlineEvent = getIsOnlineEventByAddress(addressName);

			setAddress(undefined);
			setIsOnlineEvent(isOnlineEvent);
			setOnlineUrl(isOnlineEvent ? addressName : undefined);
		}}
		textFieldProps={{
			InputProps: {
				startAdornment: (<Box
						component={isOnlineEvent ? GlobalIcon : PlaceIcon}
						width={20}
						height={20}
						style={{
							color: Colors.white,
						}}
					/>)
			}
		}}
		fullWidth
	/>);
